import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { mediaQuery } = baseVariables;

export const StyledRfpHeader = styled.div`
  .progress-tracker {
    padding-top: ${toRem(8)};
    padding-bottom: ${toRem(40)};
  }

  .view-event-summary {
    padding-top: ${toRem(36)};
    text-align: right;
    button {
      font-size: ${toRem(13)};
      padding: 0;
      background: none;
      &:focus-visible {
        outline: -webkit-focus-ring-color auto ${toRem(1)};
      }
    }
  }

  @media ${mediaQuery.md} {
    .progress-tracker {
      padding-top: ${toRem(12)};
      padding-bottom: 0;
    }
  }

  @media ${mediaQuery.lg} {
    .view-event-summary {
      padding-top: ${toRem(40)};
    }
  }
`;
